var React = require('react');

function IconRightArrowSlider (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.0001 22.9859C11.0001 22.7255 11.1003 22.4751 11.2906 22.2748L17.5924 15.995L11.3006 9.70516C10.9099 9.31455 10.9099 8.68357 11.3006 8.29296C11.6914 7.90235 12.3226 7.90235 12.7133 8.29296L19.7164 15.2939C20.0971 15.6745 20.0971 16.3355 19.7164 16.7061L12.7133 23.707C12.3226 24.0977 11.6914 24.0977 11.3006 23.707C11.1003 23.4967 11.0001 23.2463 11.0001 22.9859Z"}));
}

IconRightArrowSlider.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = IconRightArrowSlider;

IconRightArrowSlider.default = IconRightArrowSlider;
